import React from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import PageIntro from '../components/page/PageIntro'
import Footer from '../components/layout/Footer'

const DefaultLayout = ({
	icon,
	pageTitle = 'Page title',
	description = 'Description',
	children,
	video,
	videocaption,
}) => {
	return (
		<>
			<Backlink>
				<a
					href="https://www.alexwidua.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					@aw
				</a>
			</Backlink>
			<Helmet>
				<meta charSet="utf-8" />
				<title lang="en">{pageTitle}</title>
				<meta name="description" content={description} />
				<meta property="og:type" content="article" />
			</Helmet>
			<PageIntro
				pageTitle={pageTitle}
				description={description}
				video={video}
				videocaption={videocaption}
			/>
			<div className={`container`}>
				<main>{children}</main>
				<Footer />
			</div>
		</>
	)
}

const Backlink = styled.div`
	position: fixed;
	left: 1rem;
	top: 1rem;
	font-weight: 500;
	z-index: 100;

	& a {
		text-decoration: none;
		color: var(--color-text-tertiary) !important;

		&:hover {
			color: var(--color-accent) !important;
		}
	}
`

export default DefaultLayout
